import React from 'react';
import PropTypes from 'prop-types';

function ExplicitTag({ size = 16, className, style }) {
  return (
    <svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" fill="#FF0015"/>
      <path d="M5 4H11V5.47429H6.5V7.26857H10.1143V8.67429H6.5V10.5257H11V12H5V4Z" fill="white"/>
    </svg>
  )
}

ExplicitTag.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
}

export default ExplicitTag;
